export default __webpack_public_path__ + "static/media/5.738ef1b5.png";